module.exports = __webpack_public_path__ + "dash_20_app_assets/img/tp.9f954c02.png";